import { Radio } from 'antd';
import { RadioChangeEvent } from 'antd/lib/radio';
import React from 'react';
import { CapNumber } from '../../core/models/CapNumber';

interface Props {
    onSelect: (cap: number) => void;
    /** When set, clicking the already-selected cap again clears the selection (same as a dedicated clear action). */
    onClear?: () => void;
    caps: CapNumber[];
    activeCap: number | null;
    activeCapNumber: number | null;
    disabled?: boolean;
    /** Cap keys (`CapNumber.cap` / lineup field number) that cannot play (suspended, brutality, 3 fouls). */
    disabledCaps?: ReadonlySet<number>;
    capClass: string;
}

class CapSelector extends React.PureComponent<Props> {
    private handleCapButtonClick =
        (cap: number) =>
        (e: React.MouseEvent<HTMLElement>): void => {
            const { activeCap, onClear } = this.props;
            if (onClear != null && activeCap === cap) {
                e.preventDefault();
                e.stopPropagation();
                onClear();
            }
        };

    public render = (): React.ReactElement => {
        const { caps, onSelect, activeCap, disabled, disabledCaps, capClass } = this.props;
        return (
            <Radio.Group
                className={`cap-selector-wrapper ${capClass}`}
                value={activeCap ?? undefined}
                onChange={(e: RadioChangeEvent): void => onSelect(e.target.value)}
                buttonStyle="solid"
                size="large"
                disabled={disabled}
            >
                {caps
                    .sort((a: CapNumber, b: CapNumber): number => a.capNumber - b.capNumber)
                    .map(
                        (cap: CapNumber): React.ReactNode => (
                            <Radio.Button
                                key={cap.cap}
                                value={cap.cap}
                                disabled={!!disabled || (disabledCaps?.has(cap.cap) ?? false)}
                                onClick={this.handleCapButtonClick(cap.cap)}
                            >
                                {cap.capNumber}
                            </Radio.Button>
                        )
                    )}
            </Radio.Group>
        );
    };
}

export default CapSelector;
